import React, { useState } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./SoilLayer.css"; // Ensure CSS is referenced

const SoilLayer: React.FC = () => {
  const [comingSoon] = useState(true); // State to toggle "Coming Soon"

  return (
    <div className="map-wrapper">
      {comingSoon && (
        <div className="coming-soon-overlay">
          <h1 className="coming-soon-text">Soil Map Coming Soon!</h1>
        </div>
      )}
      <MapContainer center={[43.75, -87.75]} zoom={12} className="map-container">
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
      </MapContainer>
    </div>
  );
};

export default SoilLayer;
